import React, { Component } from 'react'
import _ from 'lodash'
import {
  Row,
  Col,
  Alert,
  Table,
  Button
} from 'camino-react'

import { cloudhelpDelete } from 'Utilities/CloudHelp'
import EditFormModal from 'Components/TimesheetAdmin/TimesheetAdminFormModal'

class TimesheetAdminTable extends Component {
  constructor (props) {
    super()

    this.state = {
      loading: false,
      modal: {
        method: '',
        type: ''
      },
      error: ''
    }
  }

  destroyWorkItem = (path) => {
    cloudhelpDelete(path)
      .then((response) => {
        window.location.href = response.data.redirect_url
      })
      .catch((error) => {
        this.setState({
          error: `Item ${error.response.statusText}`
        })
      })
  }

  openModal = (method, type, workItem) => {
    this.setState({
      modal: {
        method,
        type: type || ''
      },
      workItem: workItem || {},
      error: ''
    })
  }

  closeModal = () => {
    this.setState({
      modal: {
        method: '',
        type: ''
      }
    })
  }

  handleFieldValue = (key, value) => {
    this.setState((prevState) => {
      const { fields } = prevState

      const newFields = Object.assign({}, fields, { [key]: value })

      return { fields: newFields }
    })
  }

  render () {
    const {
      workRoles,
      workTypes,
      policies,
      paths
    } = this.props

    const {
      loading,
      modal,
      workItem,
      error
    } = this.state

    const {
      method,
      type
    } = modal

    const {
      openModal,
      destroyWorkItem,
      closeModal
    } = this

    const data = _.map([workRoles, workTypes].flatten(), (item) => {
      const policy = (...args) => _.get(policies, args)
      const actionIcons = []
      if (policy('update', item.itemType)) {
        if (item.itemType === 'workRole') {
          actionIcons.push({
            onClick: () => { openModal('edit', item.itemType, item) },
            text: 'Edit',
            icon: 'pencil'
          })
        } else if (item.itemType === 'workType') {
          actionIcons.push({
            onClick: () => { window.location = item.editPath },
            text: 'Edit',
            icon: 'pencil'
          })
        }
      }

      if (policy('destroy', item.itemType)) {
        actionIcons.push({
          onClick: () => {
            if (confirm(`Are you sure you want to delete this ${_.lowerCase(item.itemType)}`)) {
              destroyWorkItem(item.updatePath)
            }
          },
          text: 'Delete with confirm',
          icon: 'trash'
        })
      }

      return (
        {
          ...item,
          actionIcons
        }
      )
    })
    const columns = [
      {
        text: 'ID',
        accessor: 'id',
        maxWidth: 100,
        Cell: row => (
          <span className="decorated">
            {`#${row.value}`}
          </span>
        )
      },
      {
        text: 'Name',
        accessor: 'name',
        maxWidth: 500
      },
      {
        text: 'Type',
        accessor: '',
        Cell: ({ original }) => (
          <Row noGutters>
            {_.startCase(original.itemType)}
          </Row>
        )
      },
      {
        text: 'Actions',
        accessor: 'actionIcons',
        type: 'action_icons'
      }
    ]

    return (
      <div>
        {error && (
          <Alert alertType="error">
            {error}
          </Alert>
        )}
        <Button onClick={() => { openModal('new', 'workTypes') }}>
          New Work Type
        </Button>
        <Button onClick={() => { openModal('new', 'workRoles') }}>
          New Work Role
        </Button>

        {method && (
          <EditFormModal
            modalType={method}
            itemType={type}
            workItem={workItem}
            closeModal={closeModal}
            paths={paths}
          />
        )}
        <Table
          loading={loading}
          data={data}
          columns={columns}
          noDataText="You currently have no timesheets"
          localStoragePrefix=""
        />
      </div>
    )
  }
}

export default TimesheetAdminTable
